import clsx from 'clsx';
import React, { useState } from 'react';
import { Button, Size, Theme, } from '@havenengineering/module-shared-library/dist/components/Button';
import { triggerLogOutGTMEvent } from '../../utils/googleTag';
import styles from './Header.module.scss';
var AccountInfo;
(function (AccountInfo) {
    AccountInfo["ID"] = "accountId";
    AccountInfo["NUMBER"] = "accountNo";
})(AccountInfo || (AccountInfo = {}));
export const Header = ({ userLoggedIn, handleLogin, handleLogout, handleLogoClick, environment, displayAccountInfo = true, accountNo, accountId, hideSignButton = false, }) => {
    const [accountInfo, setAccountInfo] = useState(AccountInfo.NUMBER);
    const isDev = environment === 'development';
    const onSwapIconClick = () => {
        accountInfo === AccountInfo.ID
            ? setAccountInfo(AccountInfo.NUMBER)
            : setAccountInfo(AccountInfo.ID);
    };
    const displayAccountInformation = displayAccountInfo && isDev && (accountNo || accountId);
    return (<>
      <div id='owners-layout-header' className={clsx(styles.header, 'no-print', isDev && styles.dev)}>
        <div className={styles.logo} role='presentation' onClick={handleLogoClick}>
          <img src='https://www.haven.com/assets/logos/haven_logo_colour.svg' alt='Haven'/>
          {isDev && <span>Development</span>}
        </div>
        {userLoggedIn ? (<div className={clsx(styles.mobileStack, styles.rightPosition, {
                [styles.hasAccountInfo]: displayAccountInformation,
            })}>
            {displayAccountInformation ? (<span className={styles.accountNumber}>
                <Button onClick={onSwapIconClick} theme={Theme.MONOCHROME_THEME} scale={Size.SMALL_SIZE} icon='https://www.haven.com/assets/icons/reset.svg' iconOnly/>
                {accountInfo === AccountInfo.ID ? (<span className={styles.accountText}>
                    <strong className={styles.accountLabel}>Account ID:</strong>
                    {accountId}
                  </span>) : (<span className={styles.accountText}>
                    <strong className={styles.accountLabel}>Account No:</strong>
                    {accountNo}
                  </span>)}
              </span>) : null}
            {!hideSignButton && (<button className={clsx(styles.button, styles.signOutButton)} onClick={() => {
                    handleLogout();
                    triggerLogOutGTMEvent();
                }}>
                Sign out
              </button>)}
          </div>) : (!hideSignButton && (<button className={clsx(styles.button, styles.rightPosition)} onClick={handleLogin}>
              Sign in
            </button>))}
      </div>
      <div className={clsx(styles.printHeader, 'only-print')}>
        <img src='https://www.haven.com/assets/logos/haven_logo_colour.svg' alt='Haven'/>
      </div>
    </>);
};
